<template>
  <CosFullLayout>

    <template #aside>
      <div class="tree-box">
        <Tree
          :tree-data="treeData"
          @selectTreeData="selectTreeData"
          @emptyTreeData="emptyTreeData"
          @addNewService="addNewService"
          @successRefresh="successRefresh"
          @showEditEmit="showEditEmit"
        ></Tree>
      </div>
    </template>
    <template #main>
      <MenuDetail
        :data="selectTreeDataId"
        :addData="addData"
        :showEdit="showEdit"
        @successRefresh="successRefresh"
      ></MenuDetail>
    </template>
  </CosFullLayout>

</template>
<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import CosFullLayout from '@/components/CosFullLayout/index.vue'

import Tree from './components/Tree.vue'
import MenuDetail from './components/MenuDetail.vue'

import type { SystemSetting } from '@/types/systemSetting'
import { baseAll } from '@/api/yuntuSales/customerArea'
import { TreeDetail } from './hooks/enum'
export default defineComponent({
  name: 'DcCosLbuCustomerArea',
  components: {
    Tree,
    MenuDetail,
    CosFullLayout
  },
  setup() {
    const activeKey = ref<string>('cos_lbu')
    const treeData = ref<SystemSetting.TreeData[]>([])
    const treeDataPut = (data: SystemSetting.TreeData[]) => {
      data.forEach((item: SystemSetting.TreeData) => {
        // 在树结构最外层添加key值。为了expend可获取到对应值，实现展开背景色改色
        item.key = item.id
        if (item.children && item.children.length > 0) {
          treeDataPut(item.children)
        }
      })
    }
    const getBaseAll = async () => {
      try {
        const res: any = await baseAll({
          appId: activeKey.value
        })
        treeData.value = res.data
        treeDataPut(treeData.value)
      } catch (error) {
        console.log('getBaseAll-error: ', error)
      }
    }
    const selectTreeDataId = ref<string>()
    const selectTreeData = (node: string) => {
      selectTreeDataId.value = node
    }
    const emptyTreeData = () => {
      selectTreeDataId.value = TreeDetail.EMPTY
    }

    const successRefresh = () => {
      getBaseAll()
    }
    const showEdit = ref<any>(false)
    const showEditEmit = (value: Boolean) => {
      showEdit.value = value
    }
    const addData = ref()
    const addNewService = (parentData: SystemSetting.AddDataType) => {
      selectTreeDataId.value = TreeDetail.ADDNEW
      addData.value = parentData.data
      addData.value.appId = activeKey
    }
    onMounted(() => {
      getBaseAll()
    })
    return {
      treeData,
      activeKey,
      selectTreeData,
      selectTreeDataId,
      emptyTreeData,
      addNewService,
      addData,
      successRefresh,
      showEditEmit,
      showEdit
    }
  }
})
</script>
<style lang="scss" scoped>
#app {
  background-color: rgb(249, 249, 255);
}
.tree-box {
  padding: 16px;
  height: 79vh;
  overflow-y: scroll;
}
:deep(.dc-container main) {
  position: relative;
}
:deep(.dc-layout-main) {
  margin-top: -20px;
}
.tabs-box {
  background-color: rgb(249, 249, 255);
}
:deep(.ant-tabs-nav) {
  margin: 0 30px 7px;
  background-color: #fff;
  padding-left: 16px;
}
.wrapper-top {
  padding: 0 30px;
  background-color: rgb(249, 249, 255);
}
:deep(.dc-container aside) {
  margin-right: 8px !important;
}
:deep(.ant-tabs-top > .ant-tabs-nav) {
  margin-bottom: 8px !important;
}
</style>
